<template>
  <div class="text-center">
    <h4 class="mb-n2">
      {{ label }}
      <i
        :id="`efficiencyChartInfo-${uniqueKey}`"
        class="mdi mdi-24px mdi-info mdi-information-outline"
      ></i>
      <b-tooltip
        custom-class="info-tooltip"
        :target="`efficiencyChartInfo-${uniqueKey}`"
        variant="danger"
        :title="$t('boxInfo.tooltip.efficiency')"
      ></b-tooltip>
    </h4>
    <apexchart
      :height="height"
      type="radialBar"
      :options="options"
      :series="series"
      style="margin: 0 auto !important"
    ></apexchart>
  </div>
</template>

<script>
export default {
  name: 'BoxEfficiencyChart',
  components: {
    apexchart: () => import('vue-apexcharts'),
  },
  props: {
    height: String,
    period: Object,
    targetEfficiency: Number,
    label: String,
    actualEfficiencyValue: Number,
  },
  data: function () {
    return {
      uniqueKey: Date.now(),
    };
  },
  computed: {
    targetEfficiencyValue() {
      return this.targetEfficiency;
    },
    actualEfficiency() {
      return this.actualEfficiencyValue || 0;
    },
    series() {
      return [this.actualEfficiency ? Math.round(100 * this.actualEfficiency) / 100 : 100.0];
    },
    options() {
      const target = this.targetEfficiency;
      const actual = this.actualEfficiency;
      return {
        chart: {
          animations: {
            enabled: false,
          },
        },
        colors: [
          function ({ value }) {
            return value < target * 0.7 || actual == 0
              ? '#FF0000'
              : target * 0.7 <= value && value < target
              ? '#FC9A40'
              : '#008736';
          },
        ],
        plotOptions: {
          radialBar: {
            track: {
              background: '#191c24',
            },
            hollow: {
              margin: 0,
              size: '65%',
              background: '#293450',
            },
            dataLabels: {
              name: {
                offsetY: -10,
                color: '#fff',
                fontSize: '19px',
              },
              value: {
                color: '#fff',
                fontSize: '30px',
                show: !!actual,
              },
            },
          },
        },
        stroke: {
          lineCap: 'round',
        },
        labels: [actual ? this.$t('box.efficiency') : this.$t('dashboards.noData')],
      };
    },
  },
};
</script>
